require('particles.js');

// Init of particles.js use on index and errors pages
particlesJS('particles-js', {
    "particles": {
        "number": {
            "value": 6,
            "density": {
                "enable": true,
                "value_area": 800
            }
        },
        "color": {
            "value": "#b9b9b9"
        },
        "shape": {
            "type": "polygon",
            "stroke": {
                "width": 0,
                "color": "#000"
            },
            "polygon": {
                "nb_sides": 6
            },
        },
        "opacity": {
            "value": 0.3,
            "random": true,
            "anim": {
                "enable": false,
                "speed": 1,
                "opacity_min": 0.1,
                "sync": false
            }
        },
        "size": {
            "value": 74.97020920634164,
            "random": false,
            "anim": {
                "enable": false,
                "speed": 10,
                "size_min": 40,
                "sync": false
            }
        },
        "line_linked": {
            "enable": false,
        },
        "move": {
            "enable": true,
            "speed": 6,
            "direction": "none",
            "random": false,
            "straight": false,
            "out_mode": "bounce",
            "bounce": false,
            "attract": {
                "enable": true,
                "rotateX": 600,
                "rotateY": 1200
            }
        }
    },
    "interactivity": {
        "detect_on": "canvas",
        "events": {
            "onhover": {
                "enable": false,
            },
            "onclick": {
                "enable": false,
            },
            "resize": true
        },
    },
    "retina_detect": false
});

// -- Content vertical align of an absolute div depending of her size
// -- Used in index and errors pages
let div = document.querySelector('#middle-div');
// Get the full size of the div and divide by 2
let divWidth = div.clientWidth.toString()/2;
div.style.left = '50%';
// The margin-left must be equal to the half of the div full size
div.style.marginLeft = '-'+divWidth+'px';



// WEBPACK FOOTER //
// ./assets/js/particles.js